import { Stack } from "@mui/material";
import { LabelLessInput } from "components/Input";
import { toNumberWithFallback } from "features/shared/lib/formatters";
import { celsius } from "utils/textSymbols";

import { FLUSHING_SETTINGS_INPUT_WIDTH, TRANSIENT_INPUT_HEIGHT } from "../lib/transientForm";

type ScenarioDayNightFlushingNumericCellProps = {
  onChange: (value: number) => void;
  value: number;
};

export const ScenarioDayNightFlushingNumericCell = ({ onChange, value }: ScenarioDayNightFlushingNumericCellProps) => {
  return (
    <Stack className="gap-1">
      <LabelLessInput
        className={FLUSHING_SETTINGS_INPUT_WIDTH}
        height={TRANSIENT_INPUT_HEIGHT}
        onChange={(event) => onChange(toNumberWithFallback(event.target.value, value))}
        type="number"
        value={value}
      />
      <span className="text-lds-foreground-muted font-ds-body-regular-md">{celsius}</span>
    </Stack>
  );
};
